module.exports = __webpack_public_path__ + "img/google-play-de-black.041d7288.png";